import {TaskType} from '../constants/dataEnum';
import {filterToArray, find} from './objectHelper';

export const getBroadcastTaskByType = (selectedCard, taskState, taskType, labwareId) => {
  if (!selectedCard) return null;

  const searchCondition = {ID: selectedCard.tasks, type: taskType};
  // one aspirate source (find) to many dispense destinations (filterToArray)
  const searchFunc = taskType === TaskType.ASPIRATE ? find : filterToArray;

  if (labwareId) searchCondition.labwareID = labwareId;

  return searchFunc(taskState, searchCondition);
};

export const getBroadcastTasks = (selectedCard, taskState, labwareId) => {
  if (!selectedCard) return [];

  const taskAspirate = getBroadcastTaskByType(selectedCard, taskState, TaskType.ASPIRATE, labwareId);
  const taskDispenses = getBroadcastTaskByType(selectedCard, taskState, TaskType.DISPENSE, labwareId);

  let tasks = [];

  if (taskAspirate) {
    tasks = [...tasks, taskAspirate];
  }

  if (taskDispenses.length) {
    tasks = [...tasks, ...taskDispenses];
  }

  return tasks;
};
